import {
  inject,
  observer,
} from 'mobx-react';

import {
  Row,
  Col,
  Spin,
  Modal,
  Button,
  message,
} from 'antd'

import {
  WeaTop,
  WeaTab,
  WeaTools,
  WeaDialog,
  WeaFormItem,
  WeaRightMenu,
  WeaSearchGroup,
  WeaLocaleProvider,
  WeaAlertPage,
} from 'ecCom'

import React from 'react'
import * as mobx from 'mobx'
import {
  WeaSwitch
} from 'comsMobx';
import {
  WeaTableNew
} from 'comsMobx';
import {
  i18n
} from '../../public/i18n';
import * as PublicFunc from '../../util/pulic-func';

import '../../style/systemCard.css';

const WeaTable = WeaTableNew.WeaTable;
const getLabel = WeaLocaleProvider.getLabel;
const confirm = Modal.confirm;

@inject('hrmSystemCard')

@observer
class SystemCard extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.init();
  }


  init() {
    const {
      hrmSystemCard
    } = this.props;
    const {
      getHasRight,
    } = hrmSystemCard;

    getHasRight();
  }

  getViewCards() {
    const {
      hrmSystemCard
    } = this.props;
    const {
      headerColumns
    } = hrmSystemCard;
    let arr = [];
    for (let i = 0; i < headerColumns.length; i++) {
      arr.push(<div style={{float: 'left',width: '150px',height: '70px',marginLeft: '30px'}}>
		  				<Row>
		  					<Col span={10}>
		  						<img src={headerColumns[i].icon} alt='' />
		  					</Col>
		  					<Col span={14}>
		  						<div>{headerColumns[i].label}</div>
		  						<div style={{color: headerColumns[i]['font-color']}}>{headerColumns[i].num}</div>
		  					</Col>
		  				</Row>
					</div>);
    }
    arr.push(<div style={{clear: 'both'}}></div>);
    return <div style={{marginTop: '25px'}}>{arr}</div>;
  }

  getPanelComponent() {
    const {
      hrmSystemCard
    } = this.props;
    const {
      condition1,
      form1
    } = hrmSystemCard;
    const {
      isFormInit
    } = form1;
    let condition = condition1;
    let form = form1;
    let formParams = form1.getFormParams();
    let arr = [];

    isFormInit && condition.map(c => {
      c.items.slice(0, 2).map(field => {
        arr.push(<Col span={10} offset={1}>
      						<WeaFormItem
                          		label={`${field.label}`}
                          		labelCol={{span: `${field.labelcol}`}}
                          		wrapperCol={{span: `${field.fieldcol}`}}>
                            		<WeaSwitch fieldConfig={field} form={form} formParams={formParams} />
                       		</WeaFormItem>
      					</Col>);
      })
    })
    return <div style={{paddingTop: '30px',paddingBottom: '30px'}}><Row>{arr}</Row></div>
  }

  handleSearch() {
    const {
      hrmSystemCard
    } = this.props;
    hrmSystemCard.getTableInfo();
    hrmSystemCard.hideSearchAd();
  }

  getSecSettingForm() {
    const {
      hrmSystemCard
    } = this.props;
    const {
      condition2,
      form2,
      isSecSetting
    } = hrmSystemCard;
    const {
      isFormInit
    } = form2;

    let condition = condition2;
    let form = form2;
    let formParams = form2.getFormParams();
    let arr = [];
    let userUsbType;
    let usbstate;
    let needauto;
    if (formParams.userUsbType) userUsbType = formParams.userUsbType;
    if (formParams.usbstate) usbstate = formParams.usbstate;
    if (formParams.needauto) needauto = formParams.needauto;

    isFormInit && condition.map(c => {
      let items = c.items;
      for (let i = 0; i < items.length; i++) {
        let field = items[i];
        let domkey = (field.domkey)[0];

        if ((!userUsbType || userUsbType == '-1') && domkey !== 'userUsbType') continue;
        if (userUsbType == '4' && (!usbstate || usbstate == '0' || usbstate == '2') && (domkey == 'tokenKey' || domkey == 'serial' || domkey == 'needauto' || domkey == 'enableDate' || domkey == 'enableUsbType')) continue;
        if (userUsbType == '4' && usbstate == '1' && (!needauto || needauto == '0') && (domkey == 'tokenKey' || domkey == 'serial' || domkey == 'enableDate' || domkey == 'enableUsbType')) continue;
        if (userUsbType == '4' && usbstate == '1' && needauto == '1' && (domkey == 'tokenKey' || domkey == 'serial')) continue;

        if (userUsbType == '2' && (!usbstate || usbstate == '0' || usbstate == '2') && (domkey == 'tokenKey' || domkey == 'mobile' || domkey == 'needauto' || domkey == 'enableDate' || domkey == 'enableUsbType')) continue;
        if (userUsbType == '2' && usbstate == '1' && (!needauto || needauto == '0') && (domkey == 'tokenKey' || domkey == 'mobile' || domkey == 'enableDate' || domkey == 'enableUsbType')) continue;
        if (userUsbType == '2' && usbstate == '1' && needauto == '1' && (domkey == 'tokenKey' || domkey == 'mobile')) continue;

        if (userUsbType == '3' && (!usbstate || usbstate == '0' || usbstate == '2') && (domkey == 'serial' || domkey == 'mobile' || domkey == 'needauto' || domkey == 'enableDate' || domkey == 'enableUsbType')) continue;
        if (userUsbType == '3' && usbstate == '1' && (!needauto || needauto == '0') && (domkey == 'serial' || domkey == 'mobile' || domkey == 'enableDate' || domkey == 'enableUsbType')) continue;
        if (userUsbType == '3' && usbstate == '1' && needauto == '1' && (domkey == 'serial' || domkey == 'mobile')) continue;

        if ((domkey == 'tokenKey' || domkey == 'serial' || domkey == 'mobile') && field.viewAttr !== 3) field.viewAttr = 3;

        let dom;
        if (domkey == 'serial') {
          dom = this.getInputAndBtn(field, form, formParams);
        } else if (domkey == 'tokenKey') {
          dom = this.getInputAndBtn(field, form, formParams);
        } else {
          dom = <WeaSwitch fieldConfig={field} form={form} formParams={formParams} />;
        }

        arr.push(
          <div style={{marginTop: '10px'}}>
      					<Row>
      						<Col span={22} offset={1}>
      							<WeaFormItem
                          			label={`${field.label}`}
                          			labelCol={{span: 8}}
                          			wrapperCol={{span: 10}}>
                            			{dom}
                            			{isSecSetting ? '' : <p style={{marginTop: 5}}>{i18n.message.noAvailableCheckoutMethod()}，<a href='/spa/hrm/engine.html#/hrmengine/securitySetting' target='_blank'>{i18n.button.clickSetting()}</a>。</p> }
                       			</WeaFormItem>
      						</Col>
      					 </Row>
      				</div>
        );
      }
    })
    //将二次验证密码push到队列中
    const {
      isSecondaryVerifyUsed,
      isSecondaryVerifySetted,
      saveSecondaryPasswordSetting,
    } = hrmSystemCard;

    arr.push(
      <div style={{marginTop: '10px'}}>
          <Row>
            <Col span={22} offset={1}>
              <WeaFormItem
                label={getLabel('388412',"二次验证密码")}
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}>
                <div style={{marginTop: !isSecondaryVerifySetted ? 7 : 0}}>
                  <span>
                    {isSecondaryVerifySetted ? getLabel('15809',"已设置") : getLabel('15808',"未设置")}
                  </span>
                  { isSecondaryVerifySetted &&
                    <Button type='primary' style={{marginLeft: 111}} onClick={() => this.showConfirm()}>
                      {getLabel('26471',"停用")}
                    </Button>
                  }
                </div>
              </WeaFormItem>
            </Col>
          </Row>
      </div>)

    return <div style={{marginTop: '30px',paddingLeft: '60px'}}>{arr}</div>
  }

  showConfirm = () => {
    const {
      hrmSystemCard
    } = this.props, {
      saveSecondaryPasswordSetting
    } = hrmSystemCard;

    confirm({
      title: getLabel(131329, '信息确认'),
      content: (<div>
                  <span>{getLabel('388860',"确定要停用该管理员的二次验证密码吗？")}</span><br />
                  <span>{getLabel('388861',"为确保账户安全，请及时重设密码！")}</span>
               </div>),
      okText: getLabel(33703, '确定'),
      cancelText: getLabel(32694, '取消'),
      onOk() {
        saveSecondaryPasswordSetting(false);
      },
      onCancel() {
        return false
      },
    });
  }

  getInputAndBtn(field, form, formParams) {
    return (<div> 
      				<WeaSwitch fieldConfig={field} form={form} formParams={formParams} />
      				<div style={{position: 'absolute',top: 0,left: 220}}>
      					<Button type="primary" onClick={() => this.updateKey()}>{i18n.label.binding()}</Button>
      				</div>
      			</div>)
  }

  secSettingFormVerify() {
    const {
      hrmSystemCard
    } = this.props;
    const {
      form2,
      isSecSetting
    } = hrmSystemCard;
    const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    const isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
    const isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器

    let params = form2.getFormParams();
    let userUsbType = params.userUsbType;
    let usbstate = params.usbstate;
    let mobile = params.mobile;
    let tokenKey = params.tokenKey;
    let serial = params.serial;

    if (!isSecSetting) {
      message.warning(i18n.message.noAvailableCheckMode());
      return false;
    }
    if (!userUsbType || userUsbType == '-1') {
      // message.warning('请选择辅助校验方式！');
      // return false;
      hrmSystemCard.save();
    }

    if (userUsbType == '4' && !mobile) {
      message.warning(i18n.message.fillTelphoneNum());
      return false;
    }

    if (userUsbType == '4' && mobile && mobile.length !== 11) {
      message.warning(i18n.message.fillAvailableTelphoneNum());
      return false;
    }

    if (userUsbType == '2' && !isIE) {
      message.warning(i18n.message.htKey());
      return false;
    }

    if (userUsbType == '2' && isIE && !serial) {
      message.warning(i18n.message.fillUserKey());
      return false;
    }

    if (userUsbType == '3' && !tokenKey) {
      message.warning(i18n.message.bindToken());
      return false;
    }

    if (userUsbType == '3' && tokenKey && (!this.isdigit(tokenKey) || tokenKey.length !== 10)) {
      message.warning(i18n.message.tokenNumLen());
      return false;
    }

    this.isTokenKeyUsed({
      tokenKey: tokenKey
    });

  }

  isdigit(s) {
    var r, re;
    re = /\d*/i; //\d表示数字,*表示匹配多个数字
    r = s.match(re);
    return (r == s) ? true : false;
  }
  //序列号是否被占用
  isTokenKeyUsed(params) {
    const {
      hrmSystemCard
    } = this.props;
    WeaTools.callApi('/api/hrm/sysadmin/checkIsUsed', 'POST', params).then((data) => {
      if (data.isUsed) {
        let msg = i18n.message.tokenBinded().replace('{params}', data.lastname);
        message.warning(msg);
        // message.warning('令牌序列号已经绑定给' + data.lastname + '，不能重复绑定！');
      } else {
        hrmSystemCard.save();
      }
    })
  }

  //"用户密钥"和"令牌序列号"绑定
  updateKey() {
    const {
      hrmSystemCard
    } = this.props;
    const {
      form2
    } = hrmSystemCard;
    let needusb = (form2.getFormParams()).userUsbType;
    if (needusb == "2") {
      let returnstr = PublicFunc.getUserName() || '';
      if (returnstr !== "") {
        hrmSystemCard.setLoginId(returnstr);
      }
    } else if (needusb == "3") {
      this.bindTokenKey();
    }
  }

  bindTokenKey() {
    const title = "";
    let url = "/spa/hrm/index_mobx.html#/main/hrm/BindTokenKey?requestFrom=system&userid=" + this.props.params.hrmId;
    const dialog = ecCom.WeaTools.createDialog({
      title,
      url,
      style: {
        width: 600,
        height: 365
      },
      zIndex: 9999
    });
    dialog.show();
  }

  setSecurity() {
    const {
      hrmSystemCard
    } = this.props;
    let hrmId = this.props.params.hrmId || '';
    hrmSystemCard.hrmId = hrmId;
    let params = {
      id: hrmId
    };

    hrmSystemCard.setDialogShow();
    hrmSystemCard.getSecSettingCondition(params);
  }


  render() {
    const {
      hrmSystemCard
    } = this.props;
    const {
      tabKey,
      headerColumns,
      tableStore,
      isPanelShow,
      isSecSettingShow,
      hrmId,
      hasRight,
      loading,
    } = hrmSystemCard;
    const {
      form1
    } = hrmSystemCard;

    const btn1 = [
      (<Button type="primary" onClick={() => this.setSecurity()}>{i18n.label.securitySetting()}</Button>),
    ]

    const btn2 = [
      (<Button type="primary" onClick={() => this.handleSearch()}>{i18n.button.search()}</Button>),
      (<Button type="primary" onClick={() => {form1.reset(); hrmSystemCard.tabKey = '0'}}>{i18n.button.reset()}</Button>),
      (<Button type="primary" onClick={() => hrmSystemCard.hideSearchAd()}>{i18n.button.cancel()}</Button>),
    ];

    const btn3 = [
      (<Button type="primary" onClick={() => this.secSettingFormVerify()}>{i18n.button.save()}</Button>),
    ]

    const dropMenuDatas = [{
      key: '0',
      content: i18n.label.securitySetting(),
      icon: <i className='icon-coms-Preservation' />
    }, {
      key: '1',
      content: i18n.button.save(),
      icon: <i className='icon-coms-Preservation' />
    }, ]

    const dropMenuDatas1 = dropMenuDatas.slice(0, 1);
    const dropMenuDatas2 = dropMenuDatas.slice(1, 2);
    dropMenuDatas1.push({
      icon: <i className='icon-coms-Print-log'/>,
      content: i18n.button.log(),
      key: 'showLog',
      onClick: key => {
        window.setLogViewProps({
          logSmallType: i18n.smallType.HRM_RSOURCEMANAGER_SECURITYSETTING,
          targetId: hrmId
        });
      }
    })

    const tabName1 = [{
      key: '0',
      title: i18n.label.all()
    }, {
      key: '1',
      title: i18n.label.today()
    }, {
      key: '2',
      title: i18n.label.tswk()
    }, {
      key: '3',
      title: i18n.label.tsmth()
    }, {
      key: '4',
      title: i18n.label.tssn()
    }, {
      key: '5',
      title: i18n.label.tsyr()
    }, ]

    const items = [{
      com: (
        <Spin spinning={tableStore.loading}>
      						<WeaTable 
      						  comsWeaTableStore={tableStore}
                    hasOrder={true}
                  />
                </Spin>
      )
    }]

    if (loading) {
      return <div />
    }

    if (!hasRight) {
      return (
        <div style={{height:'100%'}}>
                    <WeaAlertPage>
                        <div style={{ color: '#000' }}>
                            {getLabel(2012, '对不起，您暂时没有权限！')}
                        </div>
                    </WeaAlertPage>
                </div>
      )
    }

    return (
      <div>
  				<WeaRightMenu 
            datas={dropMenuDatas1} 
            onClick={() => this.setSecurity()}
            collectParams={{favname: i18n.label.sysManager(),favouritetype:5}}
          >
  					<WeaTop 
            			title={i18n.label.sysManager()}
            			icon={<i className='icon-coms-hrm' />}
            			iconBgcolor='#217346'
            			loading={true}
            			buttons={btn1}
            			showDropIcon={true}
            			dropMenuDatas={dropMenuDatas1}
            			onDropMenuClick={() => this.setSecurity()}
          			/>
                  
                <WeaTab
                    selectedKey={tabKey}
                    datas={tabName1}
                    keyParam='key'
                    searchType={['base','advanced']}
                    showSearchAd={isPanelShow}
                    searchsBaseValue={form1.getFormParams().relatedname}
                    setShowSearchAd={bool => hrmSystemCard.setShowSearchAd(bool)}
                    hideSearchAd={ () => hrmSystemCard.hideSearchAd() }
                    searchsAd={this.getPanelComponent()}
                    advanceHeight={94}
                    hasMask={false}
                    buttonsAd={btn2}
                    onSearch={() => hrmSystemCard.getTableInfo()}
                    onChange={(key) => hrmSystemCard.tabClick(key)}
                    onSearchChange={v => hrmSystemCard.updateFormFields(v, '1')}
                />
                
          			
                {this.getViewCards()}

                <div className='system-card-info-group'>
                	<WeaSearchGroup
                		needTigger={true}
                		title={i18n.label.sysOpLog()}
                		showGroup={true}
          				  items={items}
          				  col={1}
                	/>
                </div>
  				</WeaRightMenu>
                <WeaDialog
            		title={i18n.label.securitySetting()}
            		icon="icon-coms-hrm"
            		iconBgcolor="#217346"
            		visible={isSecSettingShow}
            		closable={true}
            		onCancel={() => {hrmSystemCard.hideDialog(); hrmSystemCard.reset()}}
            		buttons={btn3}
            		style={{width: '600px', height: '300px'}}
          		> 
          			<WeaRightMenu datas={dropMenuDatas2} onClick={() => this.secSettingFormVerify()}>
          				{this.getSecSettingForm()}
          			</WeaRightMenu>
          		</WeaDialog>
  			</div>
    )
  }
}

export default SystemCard


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/card/SystemCard.js